import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  standalone: false,
  name: 'nomeMotorista'
})
export class NomeMotoristaPipe implements PipeTransform {

  transform(value: any[]): string {
    return value.map(item => item.Nome).join(',\n');
  }

}
